var _rect, _rect2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInviteWebIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 10,
    fill: "#EBEBEB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 25.47,
    height: 25.47,
    rx: 7,
    fill: "#929292"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4545 14C13.6545 14 13 14.6632 13 15.4737V24.3158C13 25.1263 13.6545 25.7895 14.4545 25.7895H22.0909C21.8931 25.321 21.7703 24.8235 21.7273 24.3158H14.4545V16.9474L20.2727 20.6316L26.0909 16.9474V19.1579C26.2121 19.1532 26.3334 19.1532 26.4545 19.1579C26.822 19.159 27.1881 19.2035 27.5455 19.2905V15.4737C27.5455 14.6632 26.8909 14 26.0909 14H14.4545ZM14.4545 15.4737H26.0909L20.2727 19.1579L14.4545 15.4737ZM26.0909 19.8947L24.4545 21.5526L26.0909 23.2105V22.1053C26.5731 22.1053 27.0356 22.2993 27.3766 22.6448C27.7175 22.9903 27.9091 23.4588 27.9091 23.9474C27.9091 24.2421 27.8436 24.5221 27.72 24.7726L28.5127 25.5758C28.8182 25.1116 29 24.5516 29 23.9474C29 22.3189 27.6982 21 26.0909 21V19.8947ZM23.6691 22.3189C23.3636 22.7832 23.1818 23.3432 23.1818 23.9474C23.1818 25.5758 24.4836 26.8947 26.0909 26.8947V28L27.7273 26.3421L26.0909 24.6842V25.7895C25.6087 25.7895 25.1462 25.5954 24.8053 25.2499C24.4643 24.9045 24.2727 24.4359 24.2727 23.9474C24.2727 23.6526 24.3382 23.3726 24.4618 23.1221L23.6691 22.3189V22.3189Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteWebIcon);
export default __webpack_public_path__ + "static/media/inviteWebIcon.7daba77720e847fb689a2ebda0c74c63.svg";
export { ForwardRef as ReactComponent };